export interface PaymentSettings {
  stripeSessionId: any;
  customerInfo: any | false;
}
export default {
  customerInfo: false,
} as PaymentSettings;

export const spaceName = 'caOrderPayment';
